const image_data = [
  {
    figure_name: "Isabelle",
    mask_paths: [
      "data/images/masks/Sessions_1_ground_mask.png",
      "data/images/masks/Sessions_1_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_1_ground.png",
      "data/images/Sessions_1_figure.png",
    ],
  },
  {
    figure_name: "Flora",
    mask_paths: [
      "data/images/masks/Sessions_2_ground_mask.png",
      "data/images/masks/Sessions_2_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_2_ground.png",
      "data/images/Sessions_2_figure.png",
    ],
  },
  {
    figure_name: "Luna",
    mask_paths: [
      "data/images/masks/Sessions_4_ground_mask.png",
      "data/images/masks/Sessions_4_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_4_ground.png",
      "data/images/Sessions_4_figure.png",
    ],
  },
  {
    figure_name: "Aurora",
    mask_paths: [
      "data/images/masks/Sessions_5_ground_mask.png",
      "data/images/masks/Sessions_5_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_5_ground.png",
      "data/images/Sessions_5_figure.png",
    ],
  },
  {
    figure_name: "Star",
    mask_paths: [
      "data/images/masks/Sessions_6_ground_mask.png",
      "data/images/masks/Sessions_6_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_6_ground.png",
      "data/images/Sessions_6_figure.png",
    ],
  },
  {
    figure_name: "Celeste",
    mask_paths: [
      "data/images/masks/Sessions_9_ground_mask.png",
      "data/images/masks/Sessions_9_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_9_ground.png",
      "data/images/Sessions_9_figure_var.png",
    ],
  },
  {
    figure_name: "Poppy",
    mask_paths: [
      "data/images/masks/Sessions_10_ground_mask.png",
      "data/images/masks/Sessions_10_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_10_ground.png",
      "data/images/Sessions_10_figure_var.png",
    ],
  },
  {
    figure_name: "Meadow",
    mask_paths: [
      "data/images/masks/Sessions_11_ground_mask.png",
      "data/images/masks/Sessions_11_figure_mask.png",
    ],
    render_img_paths: [
      "data/images/Sessions_11_ground.png",
      "data/images/Sessions_11_figure.png",
    ],
  },
];

export { image_data };
